import Default from './Default';

export interface Props {
    children?: React.ReactElement|Array<React.ReactElement>|null,
}

const LayoutDefault = Default;

export default LayoutDefault;
